import { Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import { PaginationConfig } from '../../models/pagination';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  standalone: false,
})
export class PaginationComponent implements DoCheck {
  /** Configuración de la paginación (obligatoria) */
  @Input() config!: PaginationConfig;

  /** Evento que emite el número de página seleccionado */
  @Output() changePage: EventEmitter<number> = new EventEmitter();

  /** Página actual */
  pageNow: number = 1;

  /** Página anterior para detectar cambios */
  private _pageAnt: number = 1;

  ngDoCheck(): void {
    this.clickPagination();
  }

  /** Emite el cambio de página si ha cambiado la página actual */
  clickPagination(): void {
    if (this._pageAnt !== this.pageNow) {
      this.changePage.emit(this.pageNow);
      this._pageAnt = this.pageNow;
    }
  }
}
